<template>
  <div id="app">
    <file-pond
      name="file"
      ref="pond"
      :label-idle="idle_label"
      :allow-multiple="allow_multiple"
      v-bind:server="{
        url: api_host,
        // timeout: enterprise_setup.upload_timeout,
        process: {
          url: endpoint_url,
          headers: headers,
          withCredentials: false,
          ondata: (formData) => {
            // console.log(formData);
            Object.keys(extra_data).map((key) => {
              formData.append(key, extra_data[key]);
            });
            // formData.append('nationalcode', '1234567890');
            // formData.append('typecode', '1');
            return formData;
          },
        },
      }"
      v-bind:files="files"
      v-on:init="init"
      v-on:error="filepond_error"
      v-on:processfile="filepond_process"
    />
  </div>
</template>
<script>
import vueFilePond from "vue-filepond";
import FilePondPluginFileValidateType from "filepond-plugin-file-validate-type";
import "filepond/dist/filepond.min.css";
import { api_host, session_token, get_user_data } from "@/utils";

const FilePond = vueFilePond(FilePondPluginFileValidateType);
// FilePond.registerPlugin(FilePondPluginFileValidateType);
// FilePondPluginFileValidateType,
// FilePondPluginImagePreview

export default {
  name: "GenericUpload",
  components: { FilePond },
  computed: {
    headers() {
      let v = this;
      if (v.token_session) {
        return {
          "modul-access-token": v.token_session,
          enterprise: v.user_data.enterprise_name,
        };
      } else return {};
    },
  },
  data() {
    return {
      files: [],
      api_host,
      token_session: session_token(),
      user_data: get_user_data(),
    };
  },
  props: {
    idle_label: {
      type: String,
      default: () => {
        return this.$t("drop files here");
      },
    },
    allow_multiple: {
      type: Boolean,
      default: false,
    },
    allowed_file_types: {
      type: String,
      default: () => {
        return "image/*, application/pdf, image/jpeg, image/png";
      },
    },
    endpoint_url: {
      type: String,
      required: true,
    },
    extra_data: {
      type: Object,
      required: false,
      default: () => {
        return {};
      },
    },
  },
  methods: {
    init: function () {
      // FilePond instance methods are available on `this.$refs.pond`
    },
    filepond_error(err) {
      this.$emit("error", err);
    },
    filepond_process(event, inst) {
      if (event && event.type == "error") this.$emit("error", event.body);
      else this.$emit("success", inst);
    },
    clear() {
      this.$refs.pond.removeFiles();
    },
  },
  mounted() {},
};
</script>
<style></style>
